<?xml version="1.0" encoding="UTF-8"?>
<svg width="18" height="18" version="1.1" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
 <rect id="minus_icon" x="3" y="8" width="12" height="2" fill-rule="evenodd"/>
</svg>
